import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  HostBinding,
  QueryList,
  ViewChild,
  ViewChildren,
  AfterViewInit,
} from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';

import { ExportFilePopupComponent } from 'src/app/shared/components/export-file-popup/export-file-popup.component';

import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import {
  formatPcPortLocalAsUtc,
  formatPcUtcDateTime,
} from 'src/app/shared/helpers/pc-utc-datetime.util';

import { Chart } from 'angular-highcharts';

import * as L from 'leaflet';
import { GemininotesPopupComponent } from '../gemininotes-popup/gemininotes-popup.component';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { getOptimizationLegConsumption as getSharedOptimizationLegConsumption } from 'src/app/shared/helpers/port-database-consumption-cell.util';

@Component({
  selector: 'app-vessel-view',
  templateUrl: './vessel-view.component.html',
  styleUrls: ['./vessel-view.component.scss'],
})
export class VesselViewComponent implements AfterViewInit {
  /** TABLE */
  isFilterOpen = false;
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;

  filterForm!: FormGroup;

  paginatedData: any;
  elements: any;
  filteredData: any;
  isAtSea: boolean = false;
  /** CHARTS */

  graphChart1!: Chart;
  graphChart2!: Chart;
  graphChart3!: Chart;
  swellChart!: Chart;
  waveHeightChart!: Chart;
  distanceChart!: Chart;

  /** MAP */

  map!: L.Map;
  baseLayer!: L.TileLayer;
  vesselMarker!: L.Marker;

  routeLayer: L.LayerGroup = L.layerGroup();
  routeLine: L.Polyline | null = null;

  itemsPerPage = 100;
  pageSizeOptions: number[] = [25, 50, 100];
  currentPage = 0;

  shipNameSuggestions: any[] = [];
  portNameSuggestions: any[] = [];
  allPorts: any[] = [];

  segmentOptions: any;
  cargoOperation: string[] = [];
  selectedOperations: string[] = [];

  /** Optimization Loss/Gain sign filters (separate per leg). */
  readonly optLossGainFilterOptions = ['Positive', 'Negative', 'Zero'];
  selectedOptLossGainManeuvering: string[] = [];
  selectedOptLossGainCargoOps: string[] = [];
  selectedOptLossGainIdle: string[] = [];

  edit = false;
  save = false;

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;

  username: any;
  currentVesselData: any = null;
  isAvgPriceMissing = false;

  /** UI VARIABLES */

  isLoading = false;
  private downloadingReportKey: string | null = null;

  loadingMessage = 'Loading data please wait...';

  currentLeg: any = null;
  remarks = '';
  reportType: string = '';
  pastVoaygeRow = false;

  activeLayer: string | null = null;

  selectedConsumptionType = 'sea';

  legend = false;
  legendImg: any;

  displayProgress = 0;

  cpExpanded = false;
  designExpanded = false;
  optimizationExpanded = true;
  operationOnVsl: string = '';
  positionData: any = {};

  vesselHeaderName = '';
  vesselHeaderImo = '';
  vesselHeaderSegment = '';
  subusername: any;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private requestFormService: RequestFormService,
    private dialog: MatDialog,
    private prequestFormService: PortRequestFormServiceService,
    private overlayService: OverlapService,
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', Validators.required],
      to_date: ['', Validators.required],
      segment: [''],
      shipName: [''],
      imoNumber: [''],
      cargoOperation: [''],
      portName: [''],
    });
  }

  /** INIT */

  ngOnInit() {
    this.username = localStorage.getItem('username') ?? '';
    this.subusername = localStorage.getItem('loginPic') ?? '';
    // this.updateVesselHeader();

    this.loadData();

    const imo = localStorage.getItem('pImo');

    if (imo) {
      this.getVesselPosition(imo);
    }
  }
  getVesselPosition(imo: string) {
    this.prequestFormService.getVesselPositionVoyage(imo).subscribe(
      (res: any) => {
        const data = res?.data;
        if (!data) return;

        this.reportType = data.reportType;
        this.operationOnVsl = data.operations;
        this.positionData = data;

        if (!this.currentLeg) this.currentLeg = {};
        this.currentLeg.cargoQty = Number(data.cargo_qty || 0);
        const originalImo = String(data.vessel_imo ?? data.imo ?? imo);

        const originalVesselName = data.vesselName;

        // Mask only for Demo user
        const isDemo = this.subusername?.toLowerCase() === 'demo';

        const displayVesselName = isDemo
          ? originalImo === '9399480'
            ? 'Vessel 1'
            : 'Vessel 2'
          : originalVesselName;

        const displayImo = isDemo ? 'XXXXXXX' : originalImo;

        // AIS fetch
        this.requestFormService.getkplerList([imo]).subscribe((aisRes: any) => {
          const ais = aisRes?.data?.[0]?.AIS || null;

          this.currentVesselData = {
            ...data,
             original_vessel_imo: originalImo,
            original_vessel_name: originalVesselName,

            // Display values
            vessel_imo: displayImo,
            vesselName: displayVesselName,

            AIS: ais,
          };

          const lat = ais?.LATITUDE
            ? Number(ais.LATITUDE)
            : Number(data.latitudeResult);

          const lng = ais?.LONGITUDE
            ? Number(ais.LONGITUDE)
            : Number(data.longitudeResult);

          this.addVesselMarker(lat, lng, this.currentVesselData.vesselName);
        });
      },
      () => {
        this.toastr.error('Unable to load vessel position');
      },
    );
  }
  addVesselMarker(lat: number, lng: number, shipName: string = 'Vessel') {
    if (!this.map) return;

    if (this.vesselMarker) {
      this.map.removeLayer(this.vesselMarker);
    }

    const zoom = this.map.getZoom();

    const vessel = this.currentVesselData;
    const signalOld =
      Date.now() - new Date(vessel?.AIS?.TIMESTAMP || Date.now()).getTime() >
      21600000;

    const navStatusMap: Record<number, string> = {
      0: 'Under Way',
      1: 'At Anchor',
      2: 'Not Under Command',
      3: 'Restricted Manoeuvrability',
      5: 'Moored',
    };

    this.vesselMarker = L.marker([lat, lng], {
      icon: this.createCurrentVesselIcon(shipName, zoom),
      pane: 'markerPane',
    }).addTo(this.map);

    this.vesselMarker.bindTooltip(
      `
    <div style="
      width:270px;
      border-radius:18px;
      overflow:hidden;
      background:#fff;
      box-shadow:0 18px 45px rgba(15,23,42,.22);
      font-family:Poppins,sans-serif;
    ">
      <div style="
        background:linear-gradient(135deg,#06132f,#0b2f7a,#133ea8);
        color:#fff;
        padding:16px 18px;
      ">
        <div style="font-size:14px;font-weight:700;margin-bottom:8px;">
          🚢 ${shipName}
        </div>

        <div style="display:flex;align-items:center;gap:8px;font-size:12px;">
          <span style="
            width:10px;
            height:10px;
            border-radius:50%;
            background:${signalOld ? '#ef4444' : '#22c55e'};
            display:inline-block;
          "></span>
          ${signalOld ? 'Delayed AIS Signal' : 'Live Tracking'}
        </div>
      </div>

      <div style="padding:14px 18px;font-size:12px;color:#0f172a;">
        <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #edf2f7;">
          <span>📍 Destination</span>
          <b>${vessel?.AIS?.DESTINATION || '-'}</b>
        </div>

        <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #edf2f7;">
          <span>🧭 Navigation</span>
          <b>${navStatusMap[Number(vessel?.AIS?.NAV_STATUS)] || '-'}</b>
        </div>

        <div style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #edf2f7;">
          <span>🌊 Depth</span>
          <b>${vessel?.AIS?.DRAUGHT || '-'} m</b>
        </div>

        <div style="padding:10px 0;border-bottom:1px solid #edf2f7;">
          <div style="color:#64748b;">📌 Coordinates</div>
          <b>${lat.toFixed(3)}, ${lng.toFixed(3)}</b>
        </div>

        <div style="padding-top:10px;">
          <div style="color:#64748b;">🕒 UTC Time</div>
          <b>${vessel?.AIS?.TIMESTAMP || '-'}</b>
        </div>
      </div>
    </div>
    `,
      {
        direction: 'top',
        sticky: true,
        opacity: 1,
        interactive: true,
        className: 'custom-vessel-tooltip',
      },
    );

    this.vesselMarker.on('mouseover', () => this.vesselMarker.openTooltip());
    this.vesselMarker.on('mouseout', () => this.vesselMarker.closeTooltip());

    this.map.setView([lat, lng], 6);
  }
  formatUTCDate(dateValue: any): string {
    return formatPcUtcDateTime(dateValue);
  }

  formatPortLocalAsUTC(dateValue: any, portName?: string | null): string {
    return formatPcPortLocalAsUtc(dateValue, portName);
  }
  // getVesselPosition(imo: string) {

  //   this.prequestFormService.getVesselPositionVoyage(imo)
  //     .subscribe((res: any) => {

  //       const data = res?.data;

  //       if (!data) return;

  //       const lat = parseFloat(data.latitudeResult);
  //       const lng = parseFloat(data.longitudeResult);

  //       const vesselName = data.vesselName;

  //       this.addVesselMarker(lat, lng, vesselName);

  //     }, error => {

  //       this.toastr.error("Unable to load vessel position");

  //     });

  // }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort: Sort) => {
        this.sortData(sort);
      });
    }

    this.initializeMap();
  }

  /** DARK MODE */

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }

  /** MAP INITIALIZE (SAME AS DetailedView) */

  initializeMap(): void {
    this.map = L.map('Map', {
      zoomControl: true,
      attributionControl: false,
      minZoom: 2,
    });

    this.baseLayer = L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    ).addTo(this.map);

    this.map.createPane('routePane');
    this.map.createPane('markerPane');

    this.map.getPane('routePane')!.style.zIndex = '400';
    this.map.getPane('markerPane')!.style.zIndex = '650';

    this.map.setView([20, 70], 4);
  }

  /** ADD VESSEL MARKER */

  /** VESSEL ICON */

  createCurrentVesselIcon(shipName: string, zoomLevel: number): L.DivIcon {
    const size = Math.min(Math.max(zoomLevel * 2, 12), 40) + 6;

    // ballast detection
    const operation = (this.operationOnVsl || '').toLowerCase();
    const reportType = (this.reportType || '').toLowerCase();

    const isBallast =
      operation.includes('ballast') || reportType.includes('ballast');

    const hullColor = isBallast ? '#ff7a00' : '#7C2020';

    return L.divIcon({
      className: 'realistic-vessel-icon',
      html: `
      <div style="
        display:flex;
        flex-direction:column;
        align-items:center;
        transform:translateY(-8px);
      ">

        <svg
          width="${size * 1.6}"
          height="${size * 0.8}"
          viewBox="0 0 100 40"
          style="
            z-index:2;
            filter:drop-shadow(0 3px 6px rgba(0,0,0,.35));
          "
        >
          <polygon points="0,20 15,5 15,35" fill="${hullColor}" />
          <rect x="15" y="8" width="55" height="24" fill="${hullColor}" />
          <rect
            x="70"
            y="10"
            width="20"
            height="20"
            fill="white"
            stroke="${hullColor}"
            stroke-width="2"
          />
          <rect x="90" y="12" width="6" height="16" fill="${hullColor}" />
        </svg>

        <div style="
          margin-top:-2px;
          font-size:10px;
          font-weight:700;
          color:midnightblue;
          white-space:nowrap;
          text-transform:uppercase;
        ">
          ${shipName || 'NA'}
        </div>

      </div>
    `,
      iconSize: [size + 24, size + 28],
      iconAnchor: [(size + 24) / 2, size / 2],
    });
  }

  getIconSize(zoomLevel: number): number {
    if (zoomLevel >= 10) return 28;
    if (zoomLevel >= 7) return 22;
    return 18;
  }

  /** LOAD DATA */

  loadData() {
    this.isLoading = true;

    const vesselName = localStorage.getItem('pShipName');
    const vesselImo = localStorage.getItem('pImo');

    this.prequestFormService
      .getVesselViewData(vesselName, vesselImo)
      .subscribe({ next: (data) => {
        data = Array.isArray(data) ? data : [];
        const clientFilters: { [key: string]: (item: any) => boolean } = {
          'Eiger Shipping': (item) =>
            item.client &&
            (item.client === 'Northwell' ||
              item.client.toLowerCase() === 'eiger'),
          'Zeronorth ZN': (item) =>
            item.client && item.client.toLowerCase() === 'zeronorth',
          'Elite Shipping': (item) =>
            item.client &&
            (item.client.toLowerCase() === 'elite tankship dmcc' ||
              item.client.toLowerCase() === 'elite'),
          'Bunge Shipping': (item) =>
            item.client && item.client.toLowerCase() === 'bunge',
          'Alcor Shipping': (item) =>
            item.client &&
            (item.client.toLowerCase() === 'alcor chartering dmcc' ||
              item.client.toLowerCase() === 'alcor chartering'),
          'EMZoil Shipping': (item) =>
            item.client &&
            (item.client.toLowerCase() === 'emz oil' ||
              item.client.toLowerCase() === 'emzoil fzco' ||
              item.client.toLowerCase().includes('emz')),
          'Ethiopian Shipping & Logistics': (item) =>
            item.client.toLowerCase() === 'ethiopian shipping & logistics',
        };
        if (this.username === 'Meraki - Operations') {
          data = data;
        } else if (clientFilters[this.username]) {
          data = data.filter(clientFilters[this.username]);
        }
        this.elements = data;
        if (this.subusername?.toLowerCase() === 'demo') {
          this.elements = this.elements
            .filter((item: any) =>
              DEMO_VESSEL_PC.includes(
                String(item.vessel_imo ?? item.imo ?? item.vessel_id),
              ),
            )
            .map((item: any) => {
              const originalImo = String(
                item.vessel_imo ?? item.imo ?? item.vessel_id,
              );

              return {
                ...item,

                // Original values
                original_vessel_imo: originalImo,
                original_vessel_name: item.vessel_name,
                original_client: item.client,

                // Display values
                vessel_imo: 'XXXXXXX',
                vessel_name:
                  originalImo === '9399480' ? 'Vessel 1' : 'Vessel 2',
                client: originalImo === '9399480' ? 'Client 1' : 'Client 2',
              };
            });
        }
        // Normalize bunker shape so Optimization Consumption cells bind consistently.
        (this.elements || []).forEach((row: any) => {
          this.hydrateBunkerFromRow(row);
        });

        if (data && data.length > 0) {
          const first = this.elements[0];
          this.updateVesselHeader(first);

          const rawFirstImo = first?.original_vessel_imo || first?.vessel_imo;
          if (rawFirstImo && rawFirstImo !== 'XXXXXXX') {
            const clean = String(rawFirstImo).trim().replace(/[^0-9]/g, '');
            if (clean && !localStorage.getItem('pImo')) {
              localStorage.setItem('pImo', clean);
            }
          }

          this.currentLeg = {
            portName: first.port,
            dateTime: first.arrival_date_and_time,
            operation: first.operations,
            operations: first.operations,
            cargoQty: Number(
              first?.cargo_qty ??
                first?.cargo_weight ??
                first?.cargo_quentity ??
                0,
            ),
            lastEvent: first.event || first.operations,
            etd: first.departure_date_and_time,
          };
        } else {
          // Vessel has no port calls yet: still show its name/IMO in the header.
          this.updateVesselHeader();
        }

        this.segmentOptions = [
          ...new Set(data.map((item: any) => item.segment)),
        ];

        this.cargoOperation = [
          ...new Set(
            data
              .map((item: any) => item.operations)
              .filter((op: string) => !!op),
          ),
        ] as string[];

        this.paginateData();
        this.updatePageSizeOptions(this.elements?.length || 0);

        this.isLoading = false;
      },
      error: () => {
        // Without this the table stays on the loading skeleton forever.
        this.elements = [];
        this.paginateData();
        this.updatePageSizeOptions(0);
        this.updateVesselHeader();
        this.isLoading = false;
      } });
  }
  formatDate(date: string): string {
    if (!date) return '-';

    return new Date(date).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  /** PAGINATION */

  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;

    const pageItems = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );

    this.paginatedData = pageItems.map((item: any, index: number) => ({
      ...item,
      sNo: startIndex + index + 1,
    }));
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  private updatePageSizeOptions(total: number) {
    const options = [25, 50, 100, total].filter((v) => v > 0);
    this.pageSizeOptions = Array.from(new Set(options)).sort((a, b) => a - b);
    if (!this.pageSizeOptions.includes(this.itemsPerPage)) {
      this.itemsPerPage =
        this.pageSizeOptions[this.pageSizeOptions.length - 1] || 100;
    }
  }

  /** SORT */

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();

    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }
  private compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (
      ['arrival_date_and_time', 'departure_date_and_time'].includes(sortActive)
    ) {
      const aDate = new Date(a[sortActive]);
      const bDate = new Date(b[sortActive]);
      if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
        return (aDate.getTime() - bDate.getTime()) * (isAsc ? 1 : -1);
      }
    }

    if (a[sortActive] === null || a[sortActive] === undefined)
      return isAsc ? -1 : 1;
    if (b[sortActive] === null || b[sortActive] === undefined)
      return isAsc ? 1 : -1;

    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);
    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum - bNum) * (isAsc ? 1 : -1);
    }

    return (
      a[sortActive].toString().localeCompare(b[sortActive].toString()) *
      (isAsc ? 1 : -1)
    );
  }

  /** FILTER */

  clearClick() {
    this.filterForm.reset();
    this.selectedOperations = [];
    this.selectedOptLossGainManeuvering = [];
    this.selectedOptLossGainCargoOps = [];
    this.selectedOptLossGainIdle = [];
    this.loadData();
  }

  filterClick() {
    const fromDateRaw = this.filterForm.get('from_date')?.value;
    const toDateRaw = this.filterForm.get('to_date')?.value;
    const portName = (this.filterForm.get('portName')?.value || '')
      .toString()
      .toLowerCase()
      .trim();
    const selectedOps = this.selectedOperations.map((op) =>
      op.toLowerCase().trim(),
    );

    const fromDate = fromDateRaw ? new Date(fromDateRaw) : null;
    const toDate = toDateRaw ? new Date(toDateRaw) : null;
    if (toDate) {
      toDate.setHours(23, 59, 59, 999);
    }

    const source = this.elements || [];
    this.filteredData = source.filter((item: any) => {
      const itemDateRaw =
        item?.arrival_date_and_time || item?.departure_date_and_time;
      const itemDate = itemDateRaw ? new Date(itemDateRaw) : null;
      const itemPort = (item?.port || '').toString().toLowerCase();
      const itemOp = (item?.operations || '').toString().toLowerCase().trim();

      const matchesDate =
        (!fromDate || (itemDate && itemDate >= fromDate)) &&
        (!toDate || (itemDate && itemDate <= toDate));
      const matchesPort = !portName || itemPort.includes(portName);
      const matchesOperation =
        !selectedOps.length || selectedOps.includes(itemOp);

      const matchesOptManeuvering = this.matchesOptLossGainFilter(
        item,
        'man',
        this.selectedOptLossGainManeuvering,
      );
      const matchesOptCargoOps = this.matchesOptLossGainFilter(
        item,
        'cargo_ops',
        this.selectedOptLossGainCargoOps,
      );
      const matchesOptIdle = this.matchesOptLossGainFilter(
        item,
        'idle',
        this.selectedOptLossGainIdle,
      );

      return (
        matchesDate &&
        matchesPort &&
        matchesOperation &&
        matchesOptManeuvering &&
        matchesOptCargoOps &&
        matchesOptIdle
      );
    });

    this.currentPage = 0;
    this.paginatedData = this.filteredData.slice(0, this.itemsPerPage);
    this.isFilterOpen = false;
  }

  /**
   * Filter Optimization Loss/Gain by sign bucket.
   * Empty selection = no constraint. Positive / Negative / Zero.
   */
  private matchesOptLossGainFilter(
    item: any,
    leg: 'man' | 'cargo_ops' | 'idle',
    selected: string[],
  ): boolean {
    if (!selected?.length) {
      return true;
    }
    const value = this.getOptimizationLossGainMt(item, leg);
    if (value == null || !Number.isFinite(value)) {
      return false;
    }

    const buckets = new Set(
      selected.map((entry) => String(entry).trim().toLowerCase()),
    );
    if (value > 0) {
      return buckets.has('positive');
    }
    if (value < 0) {
      return buckets.has('negative');
    }
    return buckets.has('zero');
  }

  closeFilterDrawer(): void {
    this.isFilterOpen = false;
  }

  /** NAVIGATION */

  backClick() {
    this.router.navigate(['/pc-fleetView']);
  }

  exportClick() {
    const rawImo =
      localStorage.getItem('pImo') ||
      this.currentVesselData?.original_vessel_imo ||
      this.elements?.[0]?.original_vessel_imo ||
      this.positionData?.vessel_imo ||
      this.positionData?.imo ||
      this.elements?.[0]?.vessel_imo ||
      this.vesselHeaderImo ||
      localStorage.getItem('vesselImo') ||
      '';

    const normalizedImo = String(rawImo ?? '')
      .trim()
      .replace(/[^0-9]/g, '');

    if (!normalizedImo) {
      this.toastr.warning('Vessel IMO is missing. Please select a vessel first.');
      return;
    }

    localStorage.setItem('pImo', normalizedImo);

    const rawName =
      this.vesselHeaderName ||
      this.currentVesselData?.original_vessel_name ||
      this.currentVesselData?.vesselName ||
      this.elements?.[0]?.original_vessel_name ||
      this.elements?.[0]?.vessel_name ||
      localStorage.getItem('pShipName') ||
      '';

    this.dialog.open(ExportFilePopupComponent, {
      width: '420px',
      data: {
        imoNumber: normalizedImo,
        vesselName: rawName,
      },
    });
  }

  /** ===== FUNCTIONS REQUIRED BY HTML ===== */

  filterPortNames(event: Event) {
    const input = (event.target as HTMLInputElement).value?.toLowerCase() || '';

    this.portNameSuggestions = this.allPorts.filter((port: any) =>
      port?.portName?.toLowerCase().includes(input),
    );
  }

  toggleCP() {
    this.cpExpanded = !this.cpExpanded;
  }

  toggleDesign() {
    this.designExpanded = !this.designExpanded;
  }

  toggleOptimization() {
    this.optimizationExpanded = !this.optimizationExpanded;
  }

  updateVesselHeader(row?: any): void {
    this.vesselHeaderName =
      row?.vessel_name || localStorage.getItem('pShipName') || '';
    this.vesselHeaderImo =
      row?.vessel_imo || localStorage.getItem('pImo') || '';
    const segment = row?.segment || localStorage.getItem('pSegment') || '';
    this.vesselHeaderSegment = segment ? this.formatSegment(segment) : '';
  }

  formatFuelValue(value: number | null | undefined): string {
    if (value == null || !Number.isFinite(Number(value))) {
      return '-';
    }
    if (Number(value) === 0) {
      return '-';
    }
    return Number(value).toFixed(2);
  }

  /**
   * Actual leg consumption from vessel-view API.
   * Prefer `actual_consumption_ops` (maneuvering / cargo_ops / idle),
   * then legacy nested fields, then editable bunker mirror.
   */
  getActualLegConsumption(
    element: any,
    leg: 'man' | 'cargo_ops' | 'idle',
  ): number | null {
    const ops = element?.actual_consumption_ops;
    if (ops && typeof ops === 'object') {
      const opsKey =
        leg === 'man'
          ? 'maneuvering'
          : leg === 'cargo_ops'
            ? 'cargo_ops'
            : 'idle';
      const raw = ops[opsKey] ?? ops[leg];
      if (raw != null && raw !== '') {
        const parsed = Number(raw);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }

    const nested = element?.actual_consumptions_mt_maneuvering_cargo_idle;
    if (nested && typeof nested === 'object') {
      const nestedKey =
        leg === 'man'
          ? 'maneuvering_actual_consumption_mt'
          : leg === 'cargo_ops'
            ? 'cargo_ops_actual_consumption_mt'
            : 'idle_actual_consumption_mt';
      const raw = nested[nestedKey];
      if (raw != null && raw !== '') {
        const parsed = Number(raw);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }

    const bunker = element?.bunker;
    if (bunker && typeof bunker === 'object') {
      const raw = bunker[leg];
      if (raw != null && raw !== '') {
        const parsed = Number(raw);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }

    return null;
  }

  getOptimizationLegConsumption(
    element: any,
    key: 'optimization_man' | 'optimization_cargo_ops' | 'optimization_idle',
  ): number | null {
    this.ensureBunkerObject(element);
    return getSharedOptimizationLegConsumption(element, key);
  }

  setOptimizationLegConsumption(
    element: any,
    key: 'optimization_man' | 'optimization_cargo_ops' | 'optimization_idle',
    value: number | string | null,
  ): void {
    this.ensureBunkerObject(element);
    const parsed = value === '' || value == null ? null : Number(value);
    const next = Number.isFinite(parsed as number) ? parsed : null;
    element.bunker[key] = next;

    // Keep API object + top-level aliases in sync.
    if (
      !element.optimization_consumption_mt ||
      typeof element.optimization_consumption_mt !== 'object'
    ) {
      element.optimization_consumption_mt = {};
    }
    if (key === 'optimization_man') {
      element.optimization_man = next;
      element.optimization_maneuvering = next;
      element.optimization_manoeuvring = next;
      element.optimization_consumption_mt.manoeuvring = next;
      element.optimization_consumption_mt.maneuvering = next;
    } else if (key === 'optimization_cargo_ops') {
      element.optimization_cargo_ops = next;
      element.optimization_consumption_mt.cargo_ops = next;
    } else {
      element.optimization_idle = next;
      element.optimization_consumption_mt.idle = next;
    }
    element._optimizationConsumptionDirty = true;
  }

  canEditOptimizationConsumption(_element: any): boolean {
    // Manual entry is always allowed; Save persists via API.
    return true;
  }

  /** Show blank for null / undefined / empty string (allow 0 to display). */
  formatOptInputValue(value: number | string | null | undefined): number | string {
    if (value == null || value === '' || !Number.isFinite(Number(value))) {
      return '';
    }
    return Number(value);
  }

  isSavingOptimizationConsumption(element: any): boolean {
    return !!element?._optimizationConsumptionSaving;
  }

  private resolveVoyageViewRowId(row: any): string | number | null {
    const id = row?.unique_id ?? row?.id ?? row?._id ?? null;
    if (id === null || id === undefined || id === '') {
      return null;
    }
    return id;
  }

  /** Formats row date/time for update-optimization-consumption (e.g. 2024-03-15T08:30:00). */
  private formatOptimizationApiDateTime(value: unknown): string {
    if (value == null || value === '') {
      return '';
    }
    if (value instanceof Date) {
      if (Number.isNaN(value.getTime())) {
        return '';
      }
      return this.toOptimizationApiIsoLocal(value);
    }

    const raw = String(value).trim();
    if (!raw) {
      return '';
    }

    // Already ISO-like without timezone — pass through (trim trailing Z if present).
    const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}:\d{2})/);
    if (isoMatch) {
      return `${isoMatch[1]}T${isoMatch[2]}`;
    }

    const parsed = new Date(raw);
    if (Number.isNaN(parsed.getTime())) {
      return '';
    }
    return this.toOptimizationApiIsoLocal(parsed);
  }

  private toOptimizationApiIsoLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  private ensureBunkerObject(element: any): void {
    if (!element) {
      return;
    }
    if (!element.bunker || typeof element.bunker !== 'object') {
      element.bunker = {};
    }
  }

  /** Copies known API aliases into element.bunker for table editing/display. */
  private hydrateBunkerFromRow(element: any): void {
    if (!element) {
      return;
    }
    this.ensureBunkerObject(element);

    const setIfMissing = (key: string, value: number | null) => {
      if (element.bunker[key] != null && element.bunker[key] !== '') {
        return;
      }
      if (value != null && Number.isFinite(value)) {
        element.bunker[key] = value;
      }
    };

    /** Actual legs always mirror API `actual_consumption_ops` when present. */
    const setActualLeg = (key: string, value: number | null) => {
      if (value != null && Number.isFinite(value)) {
        element.bunker[key] = value;
      }
    };

    const ops = element.actual_consumption_ops || {};
    const nested = element.actual_consumptions_mt_maneuvering_cargo_idle || {};
    setActualLeg(
      'man',
      this.toFiniteOrNull(
        ops.maneuvering ??
          nested.maneuvering_actual_consumption_mt ??
          element.man,
      ),
    );
    setActualLeg(
      'cargo_ops',
      this.toFiniteOrNull(
        ops.cargo_ops ??
          nested.cargo_ops_actual_consumption_mt ??
          element.cargo_ops,
      ),
    );
    setActualLeg(
      'idle',
      this.toFiniteOrNull(
        ops.idle ?? nested.idle_actual_consumption_mt ?? element.idle,
      ),
    );

    const optMt = element.optimization_consumption_mt || {};
    setIfMissing(
      'optimization_man',
      this.toFiniteOrNull(
        optMt.manoeuvring ??
          optMt.maneuvering ??
          element.optimization_man ??
          element.optimization_maneuvering ??
          element.optimization_manoeuvring,
      ),
    );
    setIfMissing(
      'optimization_cargo_ops',
      this.toFiniteOrNull(
        optMt.cargo_ops ??
          element.optimization_cargo_ops,
      ),
    );
    setIfMissing(
      'optimization_idle',
      this.toFiniteOrNull(
        optMt.idle ??
          element.optimization_idle,
      ),
    );
  }

  private toFiniteOrNull(value: unknown): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  private optimizationSaveTimers = new WeakMap<
    any,
    ReturnType<typeof setTimeout>
  >();

  isVesselMasked(row?: any): boolean {
    if (this.subusername?.toLowerCase() === 'demo') {
      return true;
    }
    const imo = String(row?.vessel_imo ?? this.currentVesselData?.vessel_imo ?? '').trim();
    if (imo === 'XXXXXXX' || imo.toUpperCase().includes('X')) {
      return true;
    }
    const vesselName = String(
      row?.vessel_name ?? this.currentVesselData?.vesselName ?? '',
    ).trim();
    if (vesselName === 'Vessel 1' || vesselName === 'Vessel 2') {
      return true;
    }
    return false;
  }

  saveOptimizationConsumption(row: any, force = false): void {
    if (!row) {
      return;
    }
    if (this.isVesselMasked(row)) {
      if (force) {
        this.toastr.warning('Saving is disabled for masked vessels.');
      }
      return;
    }
    if (!force && !row._optimizationConsumptionDirty) {
      return;
    }
    this.ensureBunkerObject(row);

    const existing = this.optimizationSaveTimers.get(row);
    if (existing) {
      clearTimeout(existing);
    }

    const runSave = () => {
      this.optimizationSaveTimers.delete(row);
      if (this.isVesselMasked(row)) {
        if (force) {
          this.toastr.warning('Saving is disabled for masked vessels.');
        }
        return;
      }
      if (!force && !row._optimizationConsumptionDirty) {
        return;
      }

      const rawImo =
        row?.vessel_imo ||
        this.currentVesselData?.vessel_imo ||
        localStorage.getItem('pImo') ||
        '';
      if (this.isVesselMasked({ vessel_imo: rawImo })) {
        if (force) {
          this.toastr.warning('Saving is disabled for masked vessels.');
        }
        return;
      }
      const vesselImo = String(rawImo).trim().replace(/[^0-9]/g, '');
      const arrival = this.formatOptimizationApiDateTime(
        row?.arrival_date_and_time,
      );
      const departure = this.formatOptimizationApiDateTime(
        row?.departure_date_and_time,
      );

      if (!vesselImo) {
        this.toastr.error('Cannot save: vessel IMO is missing.');
        return;
      }
      if (!arrival || !departure) {
        this.toastr.error(
          'Cannot save: arrival or departure date/time is missing.',
        );
        return;
      }

      const manVal = this.getOptimizationLegConsumption(row, 'optimization_man');
      const cargoVal = this.getOptimizationLegConsumption(row, 'optimization_cargo_ops');
      const idleVal = this.getOptimizationLegConsumption(row, 'optimization_idle');

      const payload = {
        vessel_imo: vesselImo,
        arrival_date_and_time: arrival,
        departure_date_and_time: departure,
        optimization_consumption_mt: {
          manoeuvring: manVal,
          cargo_ops: cargoVal,
          idle: idleVal,
        },
      };

      row._optimizationConsumptionSaving = true;
      this.prequestFormService
        .updateVesselViewOptimizationConsumption(payload)
        .subscribe({
          next: (res: any) => {
            row._optimizationConsumptionDirty = false;
            row._optimizationConsumptionSaving = false;

            if (!row.optimization_consumption_mt || typeof row.optimization_consumption_mt !== 'object') {
              row.optimization_consumption_mt = {};
            }
            row.optimization_consumption_mt.manoeuvring = manVal;
            row.optimization_consumption_mt.cargo_ops = cargoVal;
            row.optimization_consumption_mt.idle = idleVal;

            const message = res?.message || 'Optimization Consumption saved';
            this.toastr.success(message);
          },
          error: () => {
            row._optimizationConsumptionSaving = false;
            this.toastr.error('Failed to save Optimization Consumption');
          },
        });
    };

    if (force) {
      runSave();
      return;
    }

    // Debounce so tabbing across the 3 fields does not fire duplicate POSTs.
    const timer = setTimeout(runSave, 350);
    this.optimizationSaveTimers.set(row, timer);
  }

  getTotalConsumptionMt(element: any): string {
    const man = this.getActualLegConsumption(element, 'man') || 0;
    const cargo = this.getActualLegConsumption(element, 'cargo_ops') || 0;
    const idle = this.getActualLegConsumption(element, 'idle') || 0;
    const legTotal = man + cargo + idle;
    if (legTotal > 0) {
      return legTotal.toFixed(2);
    }

    const hsfo = element?.actual_consumption_mt?.hsfo || 0;
    const vlsfo = element?.actual_consumption_mt?.vlsfo || 0;
    const lsgo = element?.actual_consumption_mt?.lsgo || 0;
    const total = hsfo + vlsfo + lsgo;
    return total === 0 ? '-' : total.toFixed(2);
  }

  getCpWarrantedConsumptionMt(element: any): string {
    const cp = element?.cp_warranted_consumptions_mt;
    if (!cp) {
      return '-';
    }
    const total = (cp.hsfo || 0) + (cp.vlsfo || 0) + (cp.lsgo || 0);
    return total === 0 ? '-' : total.toFixed(2);
  }

  getTotalOptimizationConsumptionMt(element: any): string {
    const man =
      this.getOptimizationLegConsumption(element, 'optimization_man');
    const cargo =
      this.getOptimizationLegConsumption(element, 'optimization_cargo_ops');
    const idle =
      this.getOptimizationLegConsumption(element, 'optimization_idle');
    if (man == null && cargo == null && idle == null) {
      return '-';
    }
    const total = (man ?? 0) + (cargo ?? 0) + (idle ?? 0);
    return total.toFixed(2);
  }

  getTechnicalBaselineConsumptionMt(element: any): string {
    const baseline = element?.technical_design_consumptions_mt;
    if (!baseline) {
      return '-';
    }
    const total =
      (baseline.hsfo || 0) + (baseline.vlsfo || 0) + (baseline.lsgo || 0);
    return total === 0 ? '-' : total.toFixed(2);
  }

  formatLossGainValue(value: number | null | undefined): string {
    if (value === 0 || value == null) {
      return '-';
    }
    return Number(value).toFixed(2);
  }

  getLossGainStyle(value: number | null | undefined): Record<string, string> {
    if (value == null || value === 0) {
      return {};
    }
    if (value > 0) {
      return { color: 'rgb(168, 210, 150)' };
    }
    return { color: 'rgb(255, 144, 144)' };
  }

  /**
   * Optimization Loss/Gain = Optimization Consumption − Actual Consumption
   * Positive (green +) = actual below optimization (saved).
   * Negative (red −) = actual above optimization (overspend).
   */
  getOptimizationLossGainMt(
    element: any,
    leg: 'man' | 'cargo_ops' | 'idle',
  ): number | null {
    const actual = this.getActualLegConsumption(element, leg);
    const optKey =
      leg === 'man'
        ? 'optimization_man'
        : leg === 'cargo_ops'
          ? 'optimization_cargo_ops'
          : 'optimization_idle';
    const optimization = this.getOptimizationLegConsumption(element, optKey);

    if (actual == null || optimization == null) {
      return null;
    }
    const diff = optimization - actual;
    return Number.isFinite(diff) ? diff : null;
  }

  formatOptimizationLossGain(
    element: any,
    leg: 'man' | 'cargo_ops' | 'idle',
  ): string {
    const value = this.getOptimizationLossGainMt(element, leg);
    if (value == null || !Number.isFinite(value)) {
      return '-';
    }
    if (value > 0) {
      return `+${value.toFixed(2)}`;
    }
    if (value < 0) {
      return value.toFixed(2); // includes leading "-"
    }
    return '-';
  }

  getOptimizationLossGainStyle(
    element: any,
    leg: 'man' | 'cargo_ops' | 'idle',
  ): Record<string, string> {
    const value = this.getOptimizationLossGainMt(element, leg);
    if (value == null || !Number.isFinite(value) || value === 0) {
      return {};
    }
    if (value > 0) {
      return { color: 'rgb(168, 210, 150)' };
    }
    return { color: 'rgb(255, 144, 144)' };
  }

  /** Sum of Optimization Loss/Gain across Maneuvering + Cargo Ops + Idle. */
  getTotalOptimizationLossGainMt(element: any): number | null {
    const legs: Array<'man' | 'cargo_ops' | 'idle'> = [
      'man',
      'cargo_ops',
      'idle',
    ];
    let total = 0;
    let hasValue = false;
    for (const leg of legs) {
      const value = this.getOptimizationLossGainMt(element, leg);
      if (value == null || !Number.isFinite(value)) {
        continue;
      }
      total += value;
      hasValue = true;
    }
    return hasValue ? total : null;
  }

  formatTotalOptimizationLossGain(element: any): string {
    const value = this.getTotalOptimizationLossGainMt(element);
    if (value == null || !Number.isFinite(value)) {
      return '-';
    }
    if (value > 0) {
      return `+${value.toFixed(2)}`;
    }
    if (value < 0) {
      return value.toFixed(2);
    }
    return '-';
  }

  getTotalOptimizationLossGainStyle(element: any): Record<string, string> {
    const value = this.getTotalOptimizationLossGainMt(element);
    if (value == null || !Number.isFinite(value) || value === 0) {
      return {};
    }
    if (value > 0) {
      return { color: 'rgb(168, 210, 150)' };
    }
    return { color: 'rgb(255, 144, 144)' };
  }

  getReportS3Url(element: any): string {
    const url =
      element?.report_s3_link ||
      element?.port_consumption_report_s3_url ||
      element?.report_s3_url ||
      '';
    return typeof url === 'string' ? url.trim() : '';
  }

  hasReport(element: any): boolean {
    return !!this.getReportS3Url(element);
  }

  isMerakiOperations(): boolean {
    return this.username === 'Meraki - Operations';
  }

  openInsights(row: any, event?: Event): void {
    if (!this.isMerakiOperations()) {
      return;
    }
    event?.stopPropagation();
    event?.preventDefault();

    if (!row) {
      this.toastr.warning('No port row selected for AI insights.');
      return;
    }

    try {
      this.dialog.open(GemininotesPopupComponent, {
        width: 'min(1180px, 96vw)',
        maxWidth: '96vw',
        maxHeight: '94vh',
        panelClass: 'ai-insights-dialog',
        backdropClass: 'ai-insights-backdrop',
        autoFocus: false,
        hasBackdrop: true,
        data: {
          ...row,
          port_consumption_report_s3_url:
            row.port_consumption_report_s3_url || row.report_s3_link,
        },
      });
    } catch (err) {
      console.error('[AI Insights] failed to open dialog', err);
      this.toastr.error(
        'Could not open AI Insights. Please refresh and try again.',
      );
    }
  }

  getColor(value: number): string {
    if (value > 0) {
      return '#a8d296'; // Positive values in green
    } else if (value < 0) {
      return '#ff9090'; // Negative values in red
    }
    return 'inherit'; // Default color for zero
  }

  onCheckboxChange(event: Event, element: any) {
    const checked = (event.target as HTMLInputElement).checked;

    element.selected = checked;
  }

  getVesselNameColor(element: any) {
    const hsfo = element?.cp_warrantedloss_or_gain_mt?.hsfo || 0;
    const vlsfo = element?.cp_warrantedloss_or_gain_mt?.vlsfo || 0;
    const lsgo = element?.cp_warrantedloss_or_gain_mt?.lsgo || 0;

    const total = hsfo + vlsfo + lsgo;

    return total < 0 ? 'red' : '';
  }

  formatSegment(value: string): string {
    if (!value) return '';

    return value.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
  }

  formatToDays(totalTime: string): string {
    if (!totalTime) return '0.00';
    if (typeof totalTime === 'number') {
      totalTime = String(totalTime);
    }

    const parts = totalTime.split(':');

    const hours = parseInt(parts[0] || '0', 10);
    const minutes = parseInt(parts[1] || '0', 10);

    const days = (hours + minutes / 60) / 24;

    return days.toFixed(2);
  }

  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }

  recalculateTotalClaim(element: any) {}

  exitEdit(row: any) {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }

  saveRemarks(row: any) {
    const payload = {
      id: row?.unique_id,
      remarks: row?.remarks,
    };

    this.prequestFormService.updateRemarks(payload).subscribe(() => {
      this.toastr.success('Remarks updated');
    });
  }

  isReportDownloading(row: any): boolean {
    return this.downloadingReportKey === this.getReportRowKey(row);
  }

  private getReportRowKey(row: any): string {
    return `${row?.unique_id || row?.port || ''}_${row?.voyage_number || ''}`;
  }

  download(row: any, event?: Event) {
    event?.stopPropagation();
    event?.preventDefault();

    const s3Url = this.getReportS3Url(row);
    if (!s3Url) {
      this.toastr.warning(
        'Report is not available for this port call.',
        'Download Unavailable',
      );
      return;
    }

    if (this.isReportDownloading(row)) {
      return;
    }

    this.callDownloadAPI(row);
  }

  private saveReportBlob(blob: Blob, row: any): void {
    const port = (row?.port || 'port').toString().replace(/\s+/g, '_');
    const voyage = row?.voyage_number || 'report';
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${port}_${voyage}.pdf`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }

  private async handleReportDownload(pdfBlob: Blob, row: any): Promise<void> {
    if (pdfBlob?.type?.includes('json')) {
      this.toastr.error(
        'Unable to download the report. Please try again.',
        'Download Failed',
      );
      return;
    }

    if (!pdfBlob?.size) {
      this.toastr.error('Received an empty report file.', 'Download Failed');
      return;
    }

    this.saveReportBlob(pdfBlob, row);
    const portLabel = row?.port || 'port call';
    this.toastr.success(
      `Report for ${portLabel} downloaded successfully.`,
      'Download Complete',
      { timeOut: 5000, closeButton: true },
    );
  }

  callDownloadAPI(row: any, version: string = '1') {
    const s3Url = this.getReportS3Url(row);
    if (!s3Url) {
      this.toastr.error(
        'Report link is missing. Please refresh and try again.',
        'Download Failed',
      );
      return;
    }

    const reportKey = this.getReportRowKey(row);
    this.downloadingReportKey = reportKey;

    const payload = {
      s3_url: s3Url,
      version: version,
    };

    this.prequestFormService.getReport(payload).subscribe({
      next: (pdfBlob: Blob) => {
        void this.handleReportDownload(pdfBlob, row).finally(() => {
          this.downloadingReportKey = null;
        });
      },
      error: () => {
        this.downloadingReportKey = null;
        this.toastr.error(
          'Unable to download the report. Please try again.',
          'Download Failed',
          { timeOut: 5000, closeButton: true },
        );
      },
    });
  }
  saveClick() {
    this.paginatedData = [];

    this.loadData();

    this.save = false;
  }
}
